import { css } from "styled-components";

const poppins_body_base = css`
  font-family: var(--font-poppins);
  font-style: normal;
`;

export const poppins_body_lg_bold = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-lg);
  font-weight: var(--text-weight-bold);
  line-height: 2.4rem;
  letter-spacing: var(--text-body-letter-spacing-lg);
`;

export const poppins_body_lg_semibold = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-lg);
  font-weight: var(--text-weight-semibold);
  line-height: 2.4rem;
  letter-spacing: var(--text-body-letter-spacing-lg);
`;

export const poppins_body_lg_medium = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-lg);
  font-weight: var(--text-weight-medium);
  line-height: 2.4rem;
  letter-spacing: var(--text-body-letter-spacing-lg);
`;

export const poppins_body_lg_regular = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-lg);
  font-weight: var(--text-weight-regular);
  line-height: 2.4rem;
  letter-spacing: var(--text-body-letter-spacing-lg);
`;

export const poppins_body_md_bold = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-md);
  font-weight: var(--text-weight-bold);
  line-height: 1.96rem;
  letter-spacing: var(--text-body-letter-spacing-md);
`;

export const poppins_body_md_semibold = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-md);
  font-weight: var(--text-weight-semibold);
  line-height: 1.96rem;
  letter-spacing: var(--text-body-letter-spacing-md);
`;

export const poppins_body_md_medium = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-md);
  font-weight: var(--text-weight-medium);
  line-height: 1.96rem;
  letter-spacing: var(--text-body-letter-spacing-md);
`;

export const poppins_body_md_regular = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-md);
  font-weight: var(--text-weight-regular);
  line-height: 1.96rem;
  letter-spacing: var(--text-body-letter-spacing-md);
`;

export const poppins_body_sm_bold = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-sm);
  font-weight: var(--text-weight-bold);
  line-height: 1.56rem;
  letter-spacing: var(--text-body-letter-spacing-sm);
`;

export const poppins_body_sm_semibold = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-sm);
  font-weight: var(--text-weight-semibold);
  line-height: 1.56rem;
  letter-spacing: var(--text-body-letter-spacing-sm);
`;

export const poppins_body_sm_medium = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-sm);
  font-weight: var(--text-weight-medium);
  line-height: 1.56rem;
  letter-spacing: var(--text-body-letter-spacing-sm);
`;

export const poppins_body_sm_regular = css`
  ${poppins_body_base};
  font-size: var(--text-body-size-sm);
  font-weight: var(--text-weight-regular);
  line-height: 1.56rem;
  letter-spacing: var(--text-body-letter-spacing-sm);
`;
